<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from 'vue-good-table';
const dropdownsApi = ClientFactory.get("dropdowns");
const departmentApi = ClientFactory.get("departments");
const emulationApi = ClientFactory.get("emulations");

export default {
  components: {
      VueGoodTable
  },
  data(){
    return {
      total: 0,
      emulation_delete_id: 0,
      department_id: null,
      employee_id: null,
      emulation_group_id:0,
      year: new Date().getFullYear(),
      note:"",
      columns: [
        {
          label: 'Họ và Tên',
          field: 'full_name',
          thClass: 'emu-report-th  text-center text-center',
          tdClass: 'emu-report-td  text-left',
        },
        {
          label: 'Tháng 1',
          field: 't1',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Tháng 2',
          field: 't2',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Tháng 3',
          field: 't3',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Tháng 4',
          field: 't4',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Tháng 5',
          field: 't5',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Tháng 6',
          field: 't6',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Tháng 7',
          field: 't7',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Tháng 8',
          field: 't8',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Tháng 9',
          field: 't9',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Tháng 10',
          field: 't10',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Tháng 11',
          field: 't11',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Tháng 12',
          field: 't12',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Loại A',
          field: 'A',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Loại B',
          field: 'B',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        },
        {
          label: 'Loại C',
          field: 'C',
          thClass: 'emu-report-th  text-center width-status',
          tdClass: 'emu-report-td  text-center width-status',
        }
      ],
       data: [],
      years: [],
      departments:[],
      group_emulation:[],
      state: {
          dialog: {
              detail: false,
              delete: false
          }
      },
    };
  },
  async created() {
    this.department_id= this.AppActiveUser.department_id;
    this.employee_id= this.AppActiveUser.employee_id;
    this.years = await dropdownsApi.get(dropdownsApi.type.YEARS);
   // this.departments = await dropdownsApi.get(dropdownsApi.type.DEPARTMENTS);
    const params = {
        department_type: 1,
      };

    const {data} = await departmentApi.get_department_byuser(params);
    this.departments = data.map(item=>{
      return{
        label:item.name,
        value:item.id
      }
    })
     // console.log(result);
    this.getEmulationGroup();
  },
  methods: {
     ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
    getEmulation: async function () {
      this.loading(this.$vs);
      const { data } = await emulationApi.reportByDepartment(this.department_id,this.year,this.emulation_group_id);
      this.closeLoading();
      this.checkResponseData(data);
    },
    getEmulationGroup: async function () {
      const { data } = await emulationApi.getGroupByEmployee(this.employee_id);
      
      if(data.status == "success")
      { 
          if(data.data[0].groups != null) {
            this.emulation_group_id = data.data[0].groups[0].value;
            this.group_emulation = data.data[0].groups;
            this.getEmulation();
          }else
          {
            this.group_emulation =[];
          } 
      }
    },
    checkResponseData(data) {
      this.data = [];
      if(data.status == "success")
      { 
        if(data.data[0].departments[0].department_id != undefined)
          this.data = data.data[0].departments;
        else
          this.data = [];
      }else{
        if(data.message !== 'Xin lỗi, không có dữ liệu')
        {
          this.notify({
            error:true,
            title: "Thông báo",
            text: data.message
          });
        }
      }
     },

    rowStyleClassFn(row) {
      return row.is_title > 0 ? 'header-row' : '';
    },
    searchEmulation(){
      //console.log(this.year);
      this.getEmulation();
    },
    /**
     * Tải bản chấm công (excel)
     */
    downloadReport: async function() {
      this.loading(this.$vs);
      const response = await emulationApi.downloadReportByDepartment(this.department_id,this.year,this.emulation_group_id);
      this.closeLoading();
      
      if(typeof response === 'undefined' || response.status === 'failed') {
          return this.notify({
              error: true,
              text: response.message || "Unknow error",
          })
      }
      //console.log(response);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `tong_hop_thi_dua_${this.year}.xlsx`)
      link.click();
      window.URL.revokeObjectURL(url);
      
    }

  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
  },
  destroyed() {
    this.closeLoading();
  }
};

</script>

<template>
  <div class="department-report">
    <CCard  class="mb-2"  >
      <CCardHeader  class="pt-1 pb-1">
           <h4>Tổng hợp điểm thi đua theo năm</h4>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow class="mb-1">
            <CCol sm="2">
              <CSelect
                :options=years
                :value.sync="year"
                class=" pt-1"
                @change="getEmulation"
              />
            </CCol>
            <CCol sm="4">
              <CSelect
                :options=departments
                :value.sync="department_id"
                class=" pt-1"
                @change="getEmulation"
              />
            </CCol>
            <CCol sm="4">
              <CSelect
                :options=group_emulation
                :value.sync="emulation_group_id"
                class="float-left pt-1"
                @change="getEmulation"
              />
              </CCol>
            <CCol sm="2">
              <label class='mb-0'>&nbsp;</label>
              <vs-button square class="float-left custom_btn_search"  @click="searchEmulation()"><i class='bx bx-search'></i>Tìm kiếm</vs-button>
            </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
      <vue-good-table
        :columns="columns"
        :rows="data"
        :sort-options="{
          enabled:false
        }"
        :group-options="{
          enabled: true,
          headerPosition: 'top'
        }"
        
        row-style-class='header-row'
      >
        <div slot="emptystate">
          Không có dữ liệu
        </div>
      </vue-good-table> 
      <CRow>
          <CCol sm="12" class="" style="margin-top:10px">
            <vs-button
              success
              square
              :disabled="this.data.length===0"
              @click="downloadReport()"
            >
              <i class="bx bxs-download"></i>&nbsp;Tải về</vs-button
            >
          </CCol>
      </CRow>
    </CCard>
  </div>
</template>

<style lang="scss">
  .department-report{
    .width-class{
      min-width: 3px !important;
    }
    .width-status{
      min-width: 10px !important;
    }
    .vs-checkbox-content{
      align-items: center;
      justify-content: center;
    }
    .header-row {
      background: #f7f8f9;
      font-size: 14px !important;
      //color: black;
    }
    .emu-report-th{
      padding: 5px 2px 5px 2px!important;
      font-size: 13px !important;
    }
    .emu-report-td{
      font-size: 13px !important;
      min-width: 10px !important;
    }
  }
</style>